import Header from "../../components/header";
import { Container, HeaderSection, ListContainer } from "../style";
import CreateBoardModal from "../../components/modals/createBoardModal";
import PaymentMethods from "../../components/payment/PaymentMethods";

const PaymentMethodsPage = () => {
  const content = {
    tabTitle: "Payments",
    tabSubTitle: `Payment Method`,
  };
  return (
    <Container>
      <HeaderSection>
        <Header content={content} hideCreateButton={true} />
        <ListContainer>
          <PaymentMethods />
        </ListContainer>
      </HeaderSection>
      <CreateBoardModal />
    </Container>
  );
};

export default PaymentMethodsPage;
